import React from "react";
import { Alert } from "reactstrap";

const SuccessAlert = ({ message }) => {
  return message && <Alert color="primary">{message}</Alert>;
};

export default SuccessAlert;
